export const CAMPAIGN_STATUS: Record<CampaignStatus, CampaignStatus> = {
  live: 'live',
  draft: 'draft',
  pending: 'pending',
  complete: 'complete',
  error: 'error',
  ['proof/services']: 'proof/services',
  ['services/draft']: 'services/draft',
  ['tracking only']: 'tracking only'
};
